"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
exports.fileList = exports.updateStatus = exports.statusList = void 0;
var utils_1 = require("../utils");
var data_1 = require("./data");
var DataSuperAdmin = __importStar(require("./superadmin"));
var MockData = __importStar(require("./mock-data"));
exports.statusList = data_1.statusList();
exports.updateStatus = DataSuperAdmin.statusUpdate;
exports.fileList = function (uuid) { return Promise.resolve([]); };
var UserAuthenticationDataInterface = (function () {
    function UserAuthenticationDataInterface(userUuid, withBackend) {
        var _this = this;
        this.list = function () {
            if (!_this.withBackend) {
                return Promise.resolve(MockData.authenticationMethods);
            }
            return utils_1.request('/superadmin/user/authentication/list', {
                uuid: _this.userUuid
            });
        };
        this.detail = function (uuid) {
            if (!_this.withBackend) {
                var item = MockData.authenticationMethods.find(function (d) { return d.id === uuid; });
                return Promise.resolve(item || MockData.authenticationMethods[0]);
            }
            return utils_1.request('/superadmin/user/authentication/detail', { id: uuid });
        };
        this.insert = function (data) {
            if (!_this.withBackend) {
                return Promise.resolve({ id: 'uuid1' });
            }
            return utils_1.request('/superadmin/user/authentication/insert', __assign(__assign({}, data), { user: { uuid: _this.userUuid } }));
        };
        this.update = function (d) {
            if (!_this.withBackend) {
                return Promise.resolve(true);
            }
            if (d.type) {
                delete d.type.name;
            }
            delete d.user;
            return utils_1.request('/superadmin/user/authentication/update', d);
        };
        this.deleteById = function (uuid) {
            if (!_this.withBackend) {
                return Promise.resolve(true);
            }
            return utils_1.request('/superadmin/user/authentication/delete', { uuid: uuid });
        };
        this.userUuid = userUuid;
        this.withBackend = Boolean(withBackend);
    }
    return UserAuthenticationDataInterface;
}());
exports["default"] = UserAuthenticationDataInterface;
